import { Events } from '@/types/types'
import mitt from 'mitt'

const eventBus = mitt<Events>()
export function useEventBus() {
  return eventBus
}
